import SpiritualGrowth from './SpiritualGrowth'

export default SpiritualGrowth
// eslint-disable-next-line import/export
export * from './SpiritualGrowth'
